import React from "react";
import { RowsPhotoAlbum } from "react-photo-album";
import "react-photo-album/rows.css";
import { BlockImages } from "./masonry.styles";
import { optimizedImageUrl } from "../../helpers";

// Dimensions come from the API (see backend/src/utils/imageSize.js), so the
// grid can be laid out before any image loads and never jumps on resize.
// Rows without dimensions (manual records with a missing file) fall back to 4:3.
const MasonryGrid = ({ images, openImage }) => {
  const photos = images.map((image) => ({
    key: image.id ?? image.original,
    src: optimizedImageUrl("md", image.original),
    width: image.width || 4,
    height: image.height || 3,
    alt: image.title || "",
  }));

  if (photos.length === 0) return null;

  return (
    <BlockImages>
      <RowsPhotoAlbum
        photos={photos}
        spacing={15}
        targetRowHeight={200}
        onClick={({ index }) => openImage(index)}
      />
    </BlockImages>
  );
};

export default MasonryGrid;
